<div class="page-title-area page-banner-shared-decision-making">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{ 'Shared Decision Making' | translate }}</h2>
            </div>
        </div>
    </div>
</div>

<div class="heart-shape">
    <img src="assets/img/home-three/3.png" alt="Banner" />
</div>
<section class="hospital-area pb-70">
    <div class="container-fluid p-0">
        <div class="hospital-shape">
            <img src="assets/img/home-three/6.png" alt="Shape" />
        </div>

        <app-video-card *ngFor="let video of videos" [topic]="video.topic" [text]="video.text" [bullets]="video.bullets"
            [videoLength]="video.videoLength" [url]="video.url" [poster]="video.poster"
            [videoNumber]="video.videoNumber" [enableBeforeQuestions]="false"
            [enableAfterQuestions]="false"></app-video-card>


    </div>
</section>

<!-- <app-faq-pain></app-faq-pain> -->
